import script from "./SectorsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SectorsSection.vue?vue&type=script&setup=true&lang=js"

import "./SectorsSection.vue?vue&type=style&index=0&id=08f75f4d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f75f4d"]])

export default __exports__